module.exports = __webpack_public_path__ + "img/uploadSuccess.2f100ca3.jpg";